import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import AddSubFeeDiscard from './AddSubFeeDiscard';
import ListFeeSubDiscard from './ListFeeSubDiscard';

export default function FeeSubHeadDiscardWrapper() {
    const { TabPane } = Tabs;

    return (
        <>
            <Card title="Fee Sub Head Remove">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Remove" key="1">
                        <AddSubFeeDiscard />
                    </TabPane>
                    <TabPane tab="Removed List" key="2">
                    <ListFeeSubDiscard />
                    </TabPane>
                </Tabs>
            </Card>
        </>
    )
}